export default "__VITE_ASSET__D7s0Q0U$__"